// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"132":"8ff7a135","538":"0f274d46","808":"feb67e70"}[chunkId] + ".css";
};